import "Security/Context";
/** @namespace Agronomy */
NS("Agronomy");

/**
 * @class
 * @extends Security.Context
 */
Agronomy.Context = Class(Security.Context, /** @lends Agronomy.Context.prototype */ {
    /** @var {Object} User's organization reference */
    organization: null,
    organizations: [],
    /** @var {Object} User's profile reference */
    profile: null,
    provider: null,
    providers: [],
    /**
     * @inheritDoc
     */
    update(data = {}) {
        this.Parent(data);

        this.organization = data.organization;
        this.organizations = data.organizations || [];
        this.profile = data.profile;
        this.provider = data.provider;
        this.providers = data.providers || [];

        return this;
    }
});
